import React from "react";
import styles from "./DownloadApp.module.css";
import { Image } from "react-bootstrap";
import playStoreBtn from "../../../assets/images/playstore-btn.png";
import appStoreBtn from "../../../assets/images/appstore-btn.png";
import customerQR from "../../../assets/images/customer_qr.svg";
import customerPlayStore from "../../../assets/images/playstore.png";
import downloadAppImage from "../../../assets/images/download-app-img-2.png";

export default function DownloadApp() {
  return (
    <section className={styles.downloadSection}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {/* Left info content */}
          <div className={styles.infoColumn}>
            <div>
              <h2 className={styles.headline}>Download our App</h2>
              <p className={styles.description}>
                Experience MechMiles on the go with our mobile application!
                Explore the realms of MechMiles right at your fingertips. Simply
                scan the QR code to download the app and embark on your journey
                with us.
              </p>
            </div>
            <div className="store-btns">
              <div className="download-app-img">
                <a
                  href="https://play.google.com/store/apps/details?id=com.mechcustomers.app&hl=en"
                  target="_blank"
                >
                  <Image src={playStoreBtn} alt="franchise Image" />
                </a>
              </div>
              <div className="download-app-img">
                <Image src={appStoreBtn} alt="franchise Image" />
              </div>
            </div>
            <hr />

            {/* QRs */}
            <div className={styles.qrRow}>
              <div className={styles.qrItem}>
                <div className={styles.qrFrame}>
                  {/* <Image src={customerPlayStore} alt="franchise Image" /> */}
                  <Image
                    alt="Android QR Code"
                    className={styles.qrImage}
                    src={customerPlayStore}
                  />
                </div>
                <span className={styles.qrLabel}>Android</span>
              </div>
              <div className={styles.qrItem}>
                <div className={styles.qrFrame}>
                  {/* <Image src={customerQR} alt="Scan QR for" /> */}
                  <Image
                    alt="iOS QR Code"
                    className={styles.qrImage}
                    src={customerQR}
                  />
                </div>
                <span className={styles.qrLabel}>iOS</span>
              </div>
            </div>
            <span className="download-app-desc" style={{ marginTop: "-10px" }}>
              Scan the QR to download the application
            </span>
          </div>

          {/* Right Phone preview */}
          <div className={styles.previewColumn}>
            <div className={styles.phoneFrame}>
              {/* <Image src={downloadAppImage} alt="franchise Image" /> */}
              <img
                alt="franchise Image"
                className={styles.phoneImg}
                src={downloadAppImage}
              />
            </div>
            <div className={styles.haloBackground}></div>
          </div>
        </div>
      </div>
    </section>
  );
}
